import React from 'react';
import { Link } from 'react-router-dom';
import { Scissors, Dna, FileMagnifyingGlass, CurrencyInr, Question, Baby } from '@phosphor-icons/react';

const SCENARIOS = [
  { icon: Scissors, title: 'A major surgery is recommended', text: 'Bypass, joint replacement, spine or uterus surgery — a second specialist can check whether surgery is needed now and what the alternatives are.' },
  { icon: Dna, title: 'A new cancer diagnosis', text: 'A review of the biopsy, staging scans and proposed plan can confirm the diagnosis and the order of treatment before you begin.' },
  { icon: FileMagnifyingGlass, title: 'Reports or doctors disagree', text: 'When two reports or two doctors say different things, an independent reading helps you understand where the difference lies.' },
  { icon: CurrencyInr, title: 'A long or costly treatment', text: 'Before months of medicines, IVF cycles or repeated procedures, a second look can confirm the plan fits your situation.' },
  { icon: Question, title: 'The diagnosis is still unclear', text: 'If symptoms continue without a clear answer, a specialist may suggest which tests are missing.' },
  { icon: Baby, title: "A child's procedure is advised", text: 'Tonsil, adenoid, ear or heart procedures in children are worth a calm second review before you decide.' },
];

export default function SecondOpinionScenarios() {
  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8" data-testid="scenarios-section">
      <div className="max-w-7xl mx-auto">
        <div className="max-w-2xl mb-10">
          <p className="text-xs uppercase tracking-[0.2em] text-accent font-semibold mb-2">General guidance</p>
          <h2 className="font-spectral text-3xl sm:text-4xl font-bold text-primary">When a second opinion helps</h2>
          <p className="text-secondary mt-3">
            These are common situations, described in general terms. They are not individual patient cases and do not predict any outcome.
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {SCENARIOS.map((s, idx) => (
            <div key={s.title} className="bg-surface-secondary border border-primary/10 rounded-2xl p-6 hover:-translate-y-1 hover:shadow-md transition-[transform,box-shadow] duration-300" data-testid={`scenario-card-${idx}`}>
              <div className="w-11 h-11 rounded-xl bg-primary/10 flex items-center justify-center mb-4">
                <s.icon size={22} weight="duotone" className="text-primary" />
              </div>
              <h3 className="font-semibold text-primary mb-2">{s.title}</h3>
              <p className="text-sm text-secondary leading-relaxed">{s.text}</p>
            </div>
          ))}
        </div>
        <p className="text-xs text-secondary mt-6">
          A records-based opinion is not a physical examination or emergency care. In an emergency call 112. <Link to="/specialties" className="underline text-primary" data-testid="scenarios-specialties-link">See all 39 specialties</Link>.
        </p>
      </div>
    </section>
  );
}
